export { default as ChevronDoubleLeftIcon } from './ChevronDoubleLeftIcon';
